import type { InfiniteTablePropColumnPinning } from "@infinite-table/infinite-react";

export const TICKER_FIELD = "ticker";
export const NAME_FIELD = "name";
export const MIN_TICKER_COLUMN_WIDTH = 65;
export const MIN_COLUMN_WIDTH = 50;
export const MAX_COLUMN_WIDTH = 210;
export const DEFAULT_COLUMN_WIDTH = 105;

export const tickerColumnSizing = {
	minWidth: MIN_TICKER_COLUMN_WIDTH,
	defaultWidth: MIN_TICKER_COLUMN_WIDTH,
};
export const nameColumnSizing = {
	minWidth: MAX_COLUMN_WIDTH,
};
export const freezeModeColumnSizing = { defaultWidth: DEFAULT_COLUMN_WIDTH };
export const justifyModeColumnSizing = { defaultFlex: 1 };

export const columnPinning: InfiniteTablePropColumnPinning = {
	ticker: "start",
};
